export class GreenRenderer {
	canvas = null
	constructor(canvas, context) {
		this.canvas = canvas
		this.context = context
	}

	render(objects, options = {
		pixelsPerMeter: 1,
		pixelRatio: 1,
		clear: true
	}, backdrop = null) {
		let canvas = this.canvas
		let context = this.context
		if(options.clear !== false) {
			context.clearRect(0, 0, canvas.width, canvas.height)
		}
		if (backdrop) {
			context.drawImage(backdrop, 0, 0, backdrop.width, backdrop.height)
		}
		context.save()
		for (let o of objects) {
			o.render(context, options)
		}
		context.restore()
	}
}